/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("BrowserForwardSpecialAction", ["ActionApplicationService"], function (context, cls) {
  /**
   * @class BrowserForwardSpecialAction
   * @memberOf classes
   */
  class BrowserForwardSpecialAction /** @lends classes.BrowserForwardSpecialAction.prototype */ {
    /** @param actionService {classes.ActionApplicationService} */
    constructor(actionService) {
      this._actionService = actionService;
      this._listener = this._onBrowserForward.bind(this);
      if (history.pushState) {
        history.replaceState("back", "");
        history.pushState("", "");
        history.pushState("forward", "");
        history.back();
      }
      window.addEventListener("popstate", this._listener);
    }

    destroy() {
      window.removeEventListener("popstate", this._listener);
      this._actionService = null;
    }
    _onBrowserForward(event) {
      if (this._actionService && this._actionService.hasAction("browser_forward")) {
        if (event.state && event.state === "forward") {
          //back or forward
          this._actionService.executeActionByName("browser_forward");
          history.back();
        }
      }
    }
  }
  cls.BrowserForwardSpecialAction = BrowserForwardSpecialAction;
  cls.ActionApplicationService.registerSpecialAction("browser_forward", cls.BrowserForwardSpecialAction);
});
